module.exports = __webpack_public_path__ + "./workspace-pic02_c869330c52939e9a7f9fc1627421827d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionWork/workspace-pic02.jpg
// module id = 635
// module chunks = 0